<template>
    <span class="text-danger">*</span>
</template>

<script>
    export default {

        props: {

        },

        data() {
            return {

            }
        },

        methods: {

        },

    }

</script>
